export default "<app-export-xml-form></app-export-xml-form>\n";